import {Component, OnInit} from '@angular/core';
import {MenuAsideService} from '../../../../core/_base/layout';
import {RequestsService} from '../../../../provider/requests.service';
import {RequestHeaderModel} from '../../../models/request-header.model';
import {RequestActionModel} from '../../../models/request-action.model';
import {AppHotelModel} from '../../../models/app-hotel.model';
import {AppHotelService} from '../../../../provider/app-hotel.service';

@Component({
  selector: 'kt-reservation',
  templateUrl: './reservation.component.html',
  styleUrls: ['./reservation.component.scss']
})
export class ReservationComponent implements OnInit {
  currentRequest: RequestHeaderModel;
  popupVisible: boolean;
  time = new Date().getTime();
  currentHotelInfo: AppHotelModel;

  constructor(private menuAsideService: MenuAsideService,
              public requestService: RequestsService,
              private appHotel: AppHotelService) {
    this.menuAsideService.pathname$.next(window.location.pathname);
    this.appHotel.getHotelInfo(+JSON.parse(localStorage.getItem('token_form')).app_hotel_id).subscribe(
      (hotelInfo: AppHotelModel) => {
        this.currentHotelInfo = hotelInfo;
      }
    );
  }

  ngOnInit() {
  }

  getCount(data: RequestHeaderModel) {
    let person = '';
    data.requestlines.forEach(x => {
      person += x.quantity + x.unit_of_measure + '  ';
    });
    return person;
  }

  SetData(status: string) {
    this.requestService.putStatus(
      this.currentRequest.id,
      this.currentRequest.managed_by_user,
      status,
      this.currentRequest.staff_note,
      this.currentRequest.place_code
    );
    this.popupVisible = false;
  }

  Show(data: RequestHeaderModel) {
    this.currentRequest = this.requestService.room_reservation_change$.getValue().find(x => x.id == data.id);
    this.popupVisible = true;

    if (data.status == 'New') {
      const user_name = JSON.parse(localStorage.getItem('token_form')).name + ' ' + JSON.parse(localStorage.getItem('token_form')).last_name;
      this.requestService.putStatus(this.currentRequest.id, user_name, 'Viewed', '', '');
    }
  }
}
